import L from 'leaflet'
import "leaflet.markercluster";
import {initSliders} from 'slider';

'use strict';

class ZonesMap {
  constructor(elem) {
    this.elem = elem;
    this.mapElem = this.elem.querySelector('[data-display-zones-map]');
    this.mapInitialized = false;
    this.location = {};
    this.units = [];
    this.unitsMarkers = [];
    this.mapTiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ',
      maxZoom: 20,
    });
    this.markerCustomIcon = {
      iconUrl: '/themes/siblu/dist/assets/svg/marker.svg',
      shadowUrl: null,
      iconSize: [20, 30], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [10, 30], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [7, -0] // point from which the popup should open relative to the iconAnchor
    };

    this.initData();
    this.setMarkers();
    this.initMap();
    this.events();
  }

  initData() {
    if(window.chooseYourUnitZoneMarkers) {
      this.location = window.chooseYourUnitZoneMarkers.village;
      this.units = window.chooseYourUnitZoneMarkers.units;
    }
  }

  setMarkers() {
    this.unitsMarkers = [];

    if (this.units.length > 0) {
      for (let unit of this.units) {
        this.unitsMarkers.push({
          ...unit,
          id: unit.unitId,
          lat: unit.lat,
          lng: unit.lng,
          detailsUrl: unit.detailsUrl,
        });
      }
    }
  }

  events() {
    document.addEventListener('reloadChooseYourZone', () => {
      this.initData();
      this.setMarkers();
      this.initMap();
    });

    document.addEventListener('choose-your-zones-closed', () => {
      this.initMap();
    });
  }

  getLocationBounds() {
    return L.latLngBounds(parseFloat(this.location.lat), parseFloat(this.location.lng));
  }

  getLocationLatLng() {
    return L.latLng(parseFloat(this.location.lat), parseFloat(this.location.lng));
  }

  initMap() {
    if(this.mapInitialized) {
      this.map.remove();
      this.mapInitialized = false;
    }

    if (Object.keys(this.location).length > 0) {
      this.mapInitialized = !this.mapInitialized;
      const latlng = this.getLocationLatLng();
      this.map = L.map(this.mapElem, { center: latlng, zoom: 17, layers: [this.mapTiles] });
    }

    if(this.unitsMarkers.length > 0) {
      this.updateMapMarkers();
    }
  }

  updateMapMarkers() {
    if(this.mapInitialized && this.unitsMarkers.length > 0) {
      const customIcon = L.icon(this.markerCustomIcon);

      /* SET MAKERS CLUSTER GROUP */
      const markerClusterGroup = L.markerClusterGroup({ disableClusteringAtZoom: 16, spiderfyOnMaxZoom: false });

      /* SET MARKERS */
      for (let i = 0; i < this.unitsMarkers.length; i++) {
        let unitMarker = this.unitsMarkers[i];
        let marker = L.marker(L.latLng(unitMarker.lat, unitMarker.lng), { icon: customIcon });
        marker.id = unitMarker.id;

        markerClusterGroup.addLayer(marker);
      }

      /* SET MAP BOUNDS */
      this.mapBounds = markerClusterGroup.getBounds();
      this.map.fitBounds(this.mapBounds, { maxZoom: 17, padding: [30, 30] });

      /* SET MAP LAYER */
      this.map.addLayer(markerClusterGroup);
    }
  }
}

const displayZonesMaps = document.querySelectorAll('.js-display-zones-map');
displayZonesMaps.forEach((displayZonesMap) => {
  displayZonesMap.displayZonesMap = new ZonesMap(displayZonesMap);
});
export default ZonesMap;
